import styled from 'styled-components';

// Página "Petições" da aplicação Dr. Licita 3.0 — estilos do protótipo
// Figma (node 1768:4504 "Petições Elaboradas - DrLicita"), reescalados
// para a densidade do app (base 14px; o protótipo é 16px numa tela 1920):
// paleta fiel — título #21354a, botões #007bff, header da tabela #284664
// com cantos sup. 8px e borda #21354a, linhas com borda #ced4da,
// processo #6b7585, data #1a2035, aba Feedback #057757.
// O shell (Page/Sidebar/Main) é reaproveitado dos estilos do chat.

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 34px 52px 26px;

  h2 {
    font-size: 22px;
    font-weight: 800;
    line-height: 1.3;
    color: #21354a;
    margin-bottom: 30px;
  }
`;

export const SearchBar = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 18px;

  input {
    flex: 1;
  }

  select {
    width: 210px;
  }
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;

  select {
    width: 280px;
    height: 36px;
    border: 1px solid #dfdfdf;
    border-radius: 4px;
    padding: 0 10px;
    font-size: 13.5px;
    color: #808080;
    background: #fff;
  }

  span {
    flex: 1;
  }
`;

export const ToolbarButton = styled.button<{ disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 8px 14px;
  border: none;
  border-radius: 4px;
  background: #007bff;
  color: #fff;
  font-size: 14px;
  letter-spacing: -0.28px;
  line-height: 1.2;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.55 : 1)};

  i {
    font-size: 16px;
  }
`;

export const Table = styled.div`
  width: 100%;
`;

export const TableHead = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 110px 160px 150px;
  align-items: center;
  background: #284664;
  border: 1px solid #21354a;
  border-radius: 8px 8px 0 0;
  color: #fff;
  font-size: 14px;
  letter-spacing: -0.28px;
  padding: 12px 26px 12px 22px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 110px 160px 150px;
  align-items: center;
  background: #fff;
  border: 1px solid #ced4da;
  border-top: none;
  padding: 12px 26px 12px 22px;
  font-size: 14px;
  letter-spacing: -0.28px;
  color: #21354a;

  &:hover {
    background: #f8f9fa;
  }
`;

export const NameCell = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: none;
  padding: 0;
  font-size: 14px;
  letter-spacing: -0.28px;
  color: #21354a;
  text-align: left;
  cursor: pointer;
  min-width: 0;

  i {
    font-size: 17px;
    color: #5c7fa8;
    flex-shrink: 0;
  }

  &:hover {
    text-decoration: underline;
  }
`;

export const Processo = styled.span`
  color: #6b7585;
  font-size: 14px;
`;

export const Data = styled.span`
  color: #1a2035;
  font-size: 14px;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 20px;

  button {
    border: none;
    background: none;
    padding: 0;
    cursor: pointer;
    line-height: 0;

    i {
      font-size: 18px;
      color: #007bff;
    }

    &:hover i {
      color: #0056b3;
    }

    &:disabled {
      cursor: default;
      opacity: 0.35;

      &:hover i {
        color: #007bff;
      }
    }
  }
`;

export const Empty = styled.div`
  background: #fff;
  border: 1px solid #ced4da;
  border-top: none;
  padding: 34px 16px;
  text-align: center;
  color: #6c757d;
  font-size: 14px;
`;

// Breadcrumb dentro de pasta: "Petições > Nome da pasta" (Figma 1768:4604)
export const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 30px;

  button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: none;
    background: none;
    padding: 0;
    font-size: 22px;
    font-weight: 800;
    line-height: 1.3;
    color: #21354a;
    cursor: pointer;

    i {
      font-size: 20px;
      color: #21354a;
    }

    &:hover {
      text-decoration: underline;
    }
  }

  span {
    font-size: 22px;
    font-weight: 800;
    color: #21354a;
  }
`;

// Realce do alvo durante o drag & drop (linha de pasta ou raiz)
export const DropHint = styled.span<{ active?: boolean }>`
  outline: ${({ active }) => (active ? '2px dashed #007bff' : 'none')};
  outline-offset: -2px;
  display: contents;
`;

// Modais do protótipo (Nova Pasta / Upload / Renomear — Figma 1768:4936+)
export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8f9fa;
  border-radius: 6px 6px 0 0;
  padding: 16px;
  font-size: 15px;
  font-weight: 700;
  color: #21354a;

  button {
    border: none;
    background: none;
    padding: 0;
    cursor: pointer;
    line-height: 0;

    i {
      font-size: 18px;
      color: #6c757d;
    }
  }
`;

export const ModalBody = styled.div`
  padding: 24px 16px 32px;

  label {
    display: block;
    font-size: 13.5px;
    color: #495057;
    margin-bottom: 6px;
  }

  input[type='text'] {
    width: 100%;
    height: 38px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 0 10px;
    font-size: 14px;
    color: #21354a;

    &:focus {
      outline: none;
      border-color: #007bff;
    }
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  border-top: 1px solid #dee2e6;
  padding: 16px;
`;

// Modais no padrão da plataforma: header escuro ($dark) com título branco
export const ModalContainer = styled.div`
  .modal-header {
    background-color: #21354a;
    color: #fff;
  }

  .modal-header .close {
    color: #fff;
    opacity: 0.8;
    text-shadow: none;
  }
`;

export const ModalText = styled.p`
  margin: 4px 0 0;
  text-align: center;
  font-size: 14px;
  color: #495057;
  line-height: 1.5;
`;

export const GhostButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: #fff;
  color: #495057;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background: #f8f9fa;
  }
`;

export const DangerButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  background: #dc3545;
  color: #fff;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background: #c82333;
  }
`;

export const UploadArea = styled.button<{ dragging?: boolean }>`
  width: 100%;
  border: 1px dashed ${({ dragging }) => (dragging ? '#007bff' : '#ced4da')};
  background: ${({ dragging }) => (dragging ? '#eaf3ff' : '#f8f9fa')};
  border-radius: 6px;
  padding: 34px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 13.5px;
  color: #495057;
  cursor: pointer;

  i {
    font-size: 18px;
    color: #6c757d;
  }
`;

// Compartilhamento: linhas do modal (membro/empresa + ação) e marcações
export const ShareSectionTitle = styled.div`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6c757d;
  margin: 14px 0 8px;

  &:first-child {
    margin-top: 0;
  }
`;

export const ShareRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 8px 10px;
  margin-bottom: 6px;
  font-size: 14px;
  color: #21354a;

  > i {
    font-size: 18px;
    color: #5c7fa8;
  }

  button {
    margin-left: auto;
    border: none;
    background: none;
    padding: 2px;
    cursor: pointer;
    line-height: 0;

    i {
      font-size: 18px;
      color: #007bff;
    }

    &:hover i {
      color: #0056b3;
    }
  }
`;

export const ShareEmpty = styled.div`
  font-size: 13px;
  color: #8a948f;
  margin-bottom: 6px;
`;

export const OwnerTag = styled.span`
  font-size: 12px;
  color: #6b7585;
  background: #eef1f4;
  border-radius: 999px;
  padding: 2px 8px;
  margin-left: 8px;
  flex-shrink: 0;
`;

export const SharedFlag = styled.span`
  display: inline-flex;
  margin-left: 8px;
  flex-shrink: 0;

  i {
    font-size: 16px;
    color: #057757;
  }
`;

export const TeamDocBody = styled.div`
  max-height: 70vh;
  overflow-y: auto;
`;

// Aba vertical de feedback do beta, fixa na borda direita (verde/700)
export const FeedbackTab = styled.button`
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%) rotate(180deg);
  writing-mode: vertical-rl;
  background: #057757;
  border: none;
  cursor: pointer;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.5;
  padding: 34px 7px;
  border-radius: 0 4px 4px 0;
  text-decoration: none;
  z-index: 20;

  &:hover {
    color: #fff;
    filter: brightness(1.08);
  }
`;
